import * as types from './types';

export const submitForgotPassword = ({ email }) => ({
  type: types.FORGOT_PASSWORD_SUBMIT,
  payload: { email }
});
export default this;
